import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './Step.scss';

/**
 * Reusable Step in Steps
 * @function Step
 * @param {Object} props
 * @return {ReactElement}
 */
const Step = (props) => {
  const { className, countKey, isActive, isComplete, isDisabled, isError, onClick, style, title } = props;
  const memoizedOnClick = useCallback(() => onClick({ ...props, index: countKey }));

  return (
    <div
      className={classNames(
        styles.step,
        { [styles.active]: isActive },
        { [styles.complete]: isComplete },
        { [styles.error]: isError },
        { [styles.disabled]: isDisabled },
        className,
      )}
      onClick={isDisabled ? null : memoizedOnClick}
      /* zIndex Decrements to Allow for the Design to Work Correctly */
      style={{ ...style, zIndex: countKey * -1 }}
    >
      {/* Only Display the Trailing Ribbon Div for Ones Other than the First */}
      {countKey !== 1 && <div className={styles.whiteLine} />}
      {/* Ones with Trailing Ribbon Needing Padding to Center Text */}
      <div className={styles.contentContainer} style={{ paddingLeft: countKey !== 1 ? '28px' : 0 }}>
        <span
          className={classNames(
            styles.stepCount,
            { [styles.whiteText]: (isActive || isComplete || isError) },
            { [styles.disabledText]: isDisabled },
          )}
        >
          {`Step ${countKey}`}
        </span>
        <span
          className={classNames(
            styles.title,
            { [styles.whiteText]: (isActive || isComplete || isError) },
            { [styles.disabledText]: isDisabled },
          )}
        >
          {title}
        </span>
      </div>
    </div>
  );
};

Step.propTypes = {
  countKey: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  isComplete: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default Step;
